var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInspectElement(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 125,
    viewBox: "0 0 121 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3346_72395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.5701 124.046C88.8699 124.046 112.622 121.177 112.622 117.637C112.622 114.097 88.8699 111.228 59.5701 111.228C30.2703 111.228 6.51807 114.097 6.51807 117.637C6.51807 121.177 30.2703 124.046 59.5701 124.046Z",
    fill: "#F8FAFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.204 37.2249C22.9735 37.2249 24.408 35.7904 24.408 34.0209C24.408 32.2514 22.9735 30.8169 21.204 30.8169C19.4345 30.8169 18 32.2514 18 34.0209C18 35.7904 19.4345 37.2249 21.204 37.2249Z",
    stroke: "#E3E8EF",
    strokeWidth: 1.78
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.219 93.6292C113.338 93.6292 114.246 92.7217 114.246 91.6022C114.246 90.4827 113.338 89.5752 112.219 89.5752C111.099 89.5752 110.192 90.4827 110.192 91.6022C110.192 92.7217 111.099 93.6292 112.219 93.6292Z",
    stroke: "#6A7585",
    strokeWidth: 1.158
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.8921 11.0464V18.8308",
    stroke: "#6A7585",
    strokeWidth: 1.709
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 14.9385H83.7844",
    stroke: "#6A7585",
    strokeWidth: 1.709
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66309 84.0464V93.7769",
    stroke: "#6A7585",
    strokeWidth: 2.136
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.79785 88.9116H13.5284",
    stroke: "#6A7585",
    strokeWidth: 2.136
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.0009 6.408C51.7704 6.408 53.2049 4.97352 53.2049 3.204C53.2049 1.43448 51.7704 0 50.0009 0C48.2314 0 46.7969 1.43448 46.7969 3.204C46.7969 4.97352 48.2314 6.408 50.0009 6.408Z",
    fill: "#E3E8EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 34.0464C35 31.8372 36.7909 30.0464 39 30.0464H117C119.209 30.0464 121 31.8372 121 34.0464V55.0464C121 57.2555 119.209 59.0464 117 59.0464H39C36.7909 59.0464 35 57.2555 35 55.0464V34.0464Z",
    fill: "#E3E8EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 53.0459C54.9706 53.0459 59 49.0165 59 44.0459C59 39.0753 54.9706 35.0459 50 35.0459C45.0294 35.0459 41 39.0753 41 44.0459C41 49.0165 45.0294 53.0459 50 53.0459Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.6006 43.6451L49.0763 47.0461L55.1865 40.2441",
    stroke: "#99A4B3",
    strokeWidth: 2.502
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65 41.0464C65 39.9418 65.8954 39.0464 67 39.0464H92C93.1046 39.0464 94 39.9418 94 41.0464C94 42.151 93.1046 43.0464 92 43.0464H67C65.8954 43.0464 65 42.151 65 41.0464Z",
    fill: "#99A4B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95 41.0464C95 39.9418 95.8954 39.0464 97 39.0464H109C110.105 39.0464 111 39.9418 111 41.0464C111 42.151 110.105 43.0464 109 43.0464H97C95.8954 43.0464 95 42.151 95 41.0464Z",
    fill: "#99A4B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88 48.0464C88 46.9418 88.8954 46.0464 90 46.0464H99C100.105 46.0464 101 46.9418 101 48.0464C101 49.151 100.105 50.0464 99 50.0464H90C88.8954 50.0464 88 49.151 88 48.0464Z",
    fill: "#99A4B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 73.0464C19 70.8372 20.7909 69.0464 23 69.0464H92C94.2091 69.0464 96 70.8372 96 73.0464V94.0464C96 96.2555 94.2091 98.0464 92 98.0464H23C20.7909 98.0464 19 96.2555 19 94.0464V73.0464Z",
    fill: "#E3E8EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 94.0459C38.9706 94.0459 43 90.0165 43 85.0459C43 80.0753 38.9706 76.0459 34 76.0459C29.0294 76.0459 25 80.0753 25 85.0459C25 90.0165 29.0294 94.0459 34 94.0459Z",
    fill: "#F1F5F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6006 84.6451L33.0763 88.0461L39.1865 81.2441",
    stroke: "#99A4B3",
    strokeWidth: 2.502
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49 82.0464C49 80.9418 49.8954 80.0464 51 80.0464H60C61.1046 80.0464 62 80.9418 62 82.0464C62 83.151 61.1046 84.0464 60 84.0464H51C49.8954 84.0464 49 83.151 49 82.0464Z",
    fill: "#99A4B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63 82.0464C63 80.9418 63.8954 80.0464 65 80.0464H81C82.1046 80.0464 83 80.9418 83 82.0464C83 83.151 82.1046 84.0464 81 84.0464H65C63.8954 84.0464 63 83.151 63 82.0464Z",
    fill: "#99A4B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68 89.0464C68 87.9418 67.1046 87.0464 66 87.0464H51C49.8954 87.0464 49 87.9418 49 89.0464C49 90.151 49.8954 91.0464 51 91.0464H66C67.1046 91.0464 68 90.151 68 89.0464Z",
    fill: "#99A4B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 47.0459H4C1.79086 47.0459 0 48.8368 0 51.0459V73.0459C0 75.255 1.79086 77.0459 4 77.0459H82C84.2091 77.0459 86 75.255 86 73.0459V51.0459C86 48.8368 84.2091 47.0459 82 47.0459Z",
    fill: "#E3E8EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 71.0459C19.9706 71.0459 24 67.0165 24 62.0459C24 57.0753 19.9706 53.0459 15 53.0459C10.0294 53.0459 6 57.0753 6 62.0459C6 67.0165 10.0294 71.0459 15 71.0459Z",
    fill: "#E3E8EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 63.1083L14.8875 67.5454L24.387 57",
    stroke: "#6A7585",
    strokeWidth: 3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 59.0464C30 57.9418 30.8954 57.0464 32 57.0464H43C44.1046 57.0464 45 57.9418 45 59.0464C45 60.151 44.1046 61.0464 43 61.0464H32C30.8954 61.0464 30 60.151 30 59.0464Z",
    fill: "#99A4B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 59.0464C46 57.9418 46.8954 57.0464 48 57.0464H74C75.1046 57.0464 76 57.9418 76 59.0464C76 60.151 75.1046 61.0464 74 61.0464H48C46.8954 61.0464 46 60.151 46 59.0464Z",
    fill: "#99A4B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 66.0464C30 64.9418 30.8954 64.0464 32 64.0464H50C51.1046 64.0464 52 64.9418 52 66.0464C52 67.151 51.1046 68.0464 50 68.0464H32C30.8954 68.0464 30 67.151 30 66.0464Z",
    fill: "#99A4B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53 66.0464C53 64.9418 53.8954 64.0464 55 64.0464H64C65.1046 64.0464 66 64.9418 66 66.0464C66 67.151 65.1046 68.0464 64 68.0464H55C53.8954 68.0464 53 67.151 53 66.0464Z",
    fill: "#99A4B3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.824 79.3358C105.312 79.5951 105.497 80.2006 105.238 80.6883L89.9218 109.493C89.6625 109.981 89.0569 110.166 88.5693 109.906L80.6226 105.681C80.135 105.421 79.9499 104.816 80.2092 104.328L95.5248 75.524C95.7841 75.0364 96.3895 74.8513 96.8772 75.1106L104.824 79.3358Z",
    fill: "#364252"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.3197 116.267L89.0288 111.172L79.3164 106.007L76.6073 111.102C74.9988 114.128 84.7112 119.292 86.3197 116.267Z",
    fill: "#E3E8EF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.0157 74.4904C97.3778 74.1512 97.2991 73.2682 97.8669 72.8215L105.413 66.8845C106.096 66.3471 107.093 66.8768 107.029 67.7436L106.326 77.3197C106.273 78.0402 105.497 78.4686 104.859 78.1295L98.0157 74.4904Z",
    fill: "#E3E8EF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3346_72395"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 121,
    height: 125,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspectElement);
export default __webpack_public_path__ + "static/media/InspectElement.713b1a38b96601bad10b1bae25631473.svg";
export { ForwardRef as ReactComponent };